import { IndicatorClass } from "./indicator-class"
import {
  cwmJsons,
  ewmAutJsons,
  ewmEurJsons,
  ewmGlobalJsons,
  gemAutJsons,
  gemEurJsons,
  gemGlobalJsons,
  // @ts-ignore
} from "./variable-list"

export function getJsonGroup(indicatorClass: IndicatorClass) {
  switch (indicatorClass) {
    case "GEM-GLO":
      return gemGlobalJsons
    case "CWM-GLO":
      return cwmJsons
    case "GEM-AT":
      return gemAutJsons
    case "GEM-EUR":
      return gemEurJsons
    case "EWM-AT":
      return ewmAutJsons
    case "EWM-EUR":
      return ewmEurJsons
    case "EWM-GLO":
      return ewmGlobalJsons
    default:
      const exhaustiveCheck: never = indicatorClass as never
      throw new Error(`Unhandled case: ${exhaustiveCheck}`)
  }
}

export function isDecadalVar(args: {
  indicatorClass: IndicatorClass
  variableName: string
}): boolean {
  if (args.indicatorClass !== "CWM-GLO") {
    return false
  }
  const decadalVars: string[] = [
    // Should be encoded within JSON's, but I hesitate to touch the JSON's
    "Atmospheric heat content increase",
    "Earth Energy Imbalance",
    "Earth Energy Imbalance per m2",
    "Forcing-Response-Imbalance",
    "EEI-based climate change index",
    "AHC-based global warming index",
  ]
  return decadalVars.includes(args.variableName)
}

export function getGeoVariableArray(indicatorClass: IndicatorClass): string[] {
  const jsonGroup = getJsonGroup(indicatorClass)
  return Object.keys(jsonGroup) as string[]
}

let cachedJsons: Record<string, Promise<GeoVarJson>> = {}

async function _fetchSourceJsonPromise(
  geoVariable: string
): Promise<GeoVarJson> {
  const response = await fetch("/" + geoVariable)
  const json = await response.json()
  if (Object.keys(json).length === 0) {
    throw new Error(`JSON ${geoVariable} is empty`)
  }
  return json
}

export async function fetchSourceJson(
  geoVariable: string
): Promise<GeoVarJson> {
  if (!cachedJsons[geoVariable]) {
    cachedJsons[geoVariable] = _fetchSourceJsonPromise(geoVariable)
  }
  return cachedJsons[geoVariable]
}
